import { render, staticRenderFns } from "./deviceBattery.vue?vue&type=template&id=63b4b177&scoped=true&"
import script from "./deviceBattery.vue?vue&type=script&setup=true&lang=js&"
export * from "./deviceBattery.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./deviceBattery.vue?vue&type=style&index=0&id=63b4b177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4b177",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b4b177')) {
      api.createRecord('63b4b177', component.options)
    } else {
      api.reload('63b4b177', component.options)
    }
    module.hot.accept("./deviceBattery.vue?vue&type=template&id=63b4b177&scoped=true&", function () {
      api.rerender('63b4b177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/charts/deviceBattery.vue"
export default component.exports